import React, { useState, useEffect } from "react";
import pdfjs from "pdfjs-dist";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import Icon from "../../atoms/icon";
import assetify from "@quintype/framework/assetify";
import spinner from "../../../../assets/images/spinner.svg";

const PdfViewer = ({ pdfUrl, pdfPassword, clickAction, watermarkText, webView }) => {
  const [pdfDocument, setPdfDocument] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [scale, setScale] = useState(2);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(
    () => {
      // Initialize PDF.js
      pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

      // Load PDF document
      const loadingTask = pdfjs.getDocument({ url: pdfUrl, password: pdfPassword });
      loadingTask.promise.then(pdfDoc => {
        setPdfDocument(pdfDoc);
        generateThumbnails(pdfDoc);
        setIsLoading(false);
      });
    },
    [pdfUrl]
  );

  useEffect(
    () => {
      if (pdfDocument) {
        renderPage(currentPage);
        setTotalPage(pdfDocument.numPages);
      }
    },
    [pdfDocument, currentPage, scale]
  );

  useEffect(() => {
    const handleContextMenu = e => {
      e.preventDefault();
    };

    const canvas = document.getElementById("pdfCanvas");
    if (canvas) {
      canvas.addEventListener("contextmenu", handleContextMenu);

      return () => {
        canvas.removeEventListener("contextmenu", handleContextMenu);
      };
    }
  }, []);

  useEffect(
    () => {
      const handleKeyDown = event => {
        if (event.key === "ArrowLeft" && currentPage > 1) {
          prevPage();
        } else if (event.key === "ArrowRight" && currentPage < totalPage) {
          nextPage();
        }
      };

      window.addEventListener("keydown", handleKeyDown);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    },
    [currentPage, totalPage]
  );

  const renderPage = pageNumber => {
    if (!pdfDocument) return;
    pdfDocument.getPage(pageNumber).then(page => {
      const viewport = page.getViewport({ scale });
      const canvas = document.getElementById("pdfCanvas");
      const context = canvas.getContext("2d");

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const renderContext = {
        canvasContext: context,
        viewport: viewport
      };

      page.render(renderContext).promise.then(() => {
        console.log("webView:", webView);

        if (webView === "webview") {
          const webviewText = "webview";
          const fontSize = 16;
          const fontFamily = "Arial";

          const letters = webviewText.split("");

          let currentY = (viewport.height - fontSize) / 2;

          for (let i = 0; i < letters.length; i++) {
            const letter = letters[i];

            context.globalAlpha = 0.3;
            context.fillStyle = "rgba(0, 0, 0, 1)";
            context.font = `${fontSize}px ${fontFamily}`;
            context.textAlign = "center";
            context.fillText(letter, viewport.width / 2 + 450, currentY);

            currentY += fontSize;
          }
        }

        if (watermarkText) {
          context.globalAlpha = 0.3;
          context.fillStyle = "rgba(0, 0, 0, 1)";
          context.font = "20px Arial";
          context.textAlign = "center";
          context.fillText(watermarkText, viewport.width / 2, viewport.height - 20);
          context.globalAlpha = 1;
        }
      });
    });
  };

  const generateThumbnails = pdfDoc => {
    const thumbnailPromises = [];
    for (let i = 1; i <= pdfDoc.numPages; i++) {
      thumbnailPromises.push(generateThumbnail(pdfDoc, i));
    }

    Promise.all(thumbnailPromises)
      .then(thumbnails => {
        // setThumbnails(thumbnails);
      })
      .catch(error => {
        console.error("Error generating thumbnails:", error);
      });
  };

  const generateThumbnail = (pdfDoc, pageNumber) => {
    return pdfDoc.getPage(pageNumber).then(page => {
      const viewport = page.getViewport({ scale: 0.35 });
      const canvas = document.getElementById(`thumbnailCanvas${pageNumber}`);
      const context = canvas.getContext("2d");

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const renderContext = {
        canvasContext: context,
        viewport: viewport
      };

      page.render(renderContext);
    });
  };

  const zoomIn = () => {
    if (scale < 2.6) {
      setScale(scale + 0.1);
    }
  };

  const zoomOut = () => {
    if (scale > 0.2) {
      setScale(scale - 0.1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      let currenPg = currentPage - 1;
      setCurrentPage(currenPg);
      clickAction(currenPg);
    }
  };

  const nextPage = () => {
    if (currentPage < pdfDocument.numPages) {
      let currenPg = currentPage + 1;
      setCurrentPage(currenPg);
      clickAction(currenPg);
    }
  };

  const thumbClick = pNum => {
    setCurrentPage(pNum);
    clickAction(pNum);
  };

  const thumbnailDiv = () => {
    const divElements = [];

    for (let i = 1; i <= totalPage; i++) {
      divElements.push(
        <div key={i} onClick={() => thumbClick(i)}>
          <canvas id={`thumbnailCanvas${i}`} />
        </div>
      );
    }

    return divElements;
  };
  return (
    <div>
      <div className={styles["magazine-pdf-wrapper"]}>
        {isLoading ? (
          <div className={styles["pdf-loader"]}>
            <img src={assetify(spinner)} alt="Loading..." />
          </div>
        ) : (
          <div className={styles["magazine-pdf-grid"]}>
            <div className={styles["thumbnails"]}>{thumbnailDiv()}</div>
            <div className={styles["pdf-canvas"]}>
              <canvas id="pdfCanvas" />
            </div>
            <div className={styles["pdf-buttons"]}>
              <button onClick={prevPage} className={styles["prev-arrow"]} disabled={currentPage === 1}>
                <Icon type="slider-prev" />
              </button>
              <button onClick={nextPage} className={styles["next-arrow"]} disabled={currentPage === totalPage}>
                <Icon type="slider-next" />
              </button>
              <div className={styles["zoom-buttons"]}>
                <button onClick={zoomIn}>+</button>
                <button onClick={zoomOut}>-</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

PdfViewer.propTypes = {
  pdfUrl: PropTypes.string,
  pdfPassword: PropTypes.string,
  clickAction: PropTypes.func,
  watermarkText: PropTypes.string,
  webView: PropTypes.string
};

export default PdfViewer;
